import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { LabelStyle } from './LabelStyle';

const Label = ({ theme, text, icon }) => {
  const [className, setClassName] = useState('');

  useEffect(() => {
    const currentClassName = [];
    if (theme && theme.length) {
      currentClassName.push(`${theme}-theme`);
    } else {
      currentClassName.push('default-theme');
    }

    if (icon) {
      currentClassName.push('with-icon');
    }

    setClassName(currentClassName.join(' '));
  }, [theme, icon]);

  return (
    <LabelStyle className={className}>
      {icon ? <span className="icon">{icon}</span> : null}
      <span className="text">{text}</span>
    </LabelStyle>
  );
};

Label.propTypes = {
  theme: PropTypes.string,
  text: PropTypes.string.isRequired,
  icon: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.node]),
};

Label.defaultProps = {
  theme: 'default',
  icon: null,
};

export default Label;
